var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViaggiTreno',{attrs:{"title":_vm.tLabel('menu_partenze'),"faseOperativa":_vm.faseOperativa}})
}
var staticRenderFns = []

export { render, staticRenderFns }